import React, {useEffect, useState} from 'react';
import {motion} from "framer-motion";
import s from "./AccountConfirmationLetter.module.css";
import CustomDropdownForAccounts
    from "../../../../../components/ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import {Formik} from "formik";
import {useAccountsForSelect} from "../../../../../hooks/useAccountsForSelect";
import {useSelector} from "react-redux";
import {
    selectAccountForConfirmationLetter, selectAccountsByFilter,
    selectTopUpByAccount
} from "../../../../../store/reducers/TransactionsSlice/selector";
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux";
import {setFilters, setFiltersTemplates} from "../../../../../store/reducers/TransactionsSlice/TransactionsSlice";
import CustomModal from "../../../../../components/ui/CustomModal/CustomModal";
import styles from "../../../../../styles/styles.module.css";
import iconInfo from "../../../../../assets/img/personalAccount/info-circle.svg";
import TransparentButton from "../../../../../components/ui/TransparentButton/TransparentButton";
import MyBtn from "../../../../../components/ui/MyBtn/MyBtn";
import {getAccountConfirmationLetterThunk, setTokenState} from "../../../../../store/reducers/ActionCreators";
import CustomCheckbox from '../../../../../components/ui/customCheckbox/CustomCheckbox';
import CustomCheckbox1 from '../../../../../components/ui/CustomCheckbox1/CustomCheckbox1';
import info from "../../../../../assets/img/personalAccount/information.svg";
import {Popover} from "antd";

interface Helper {
    transferValues: {
        accountNumber: string;
    };
}

const DetailsForBankTransferHelper: React.FC<Helper> = ({ transferValues }) => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (transferValues.accountNumber) {
            dispatch(setFilters({ accountNumber: transferValues.accountNumber }));
        }
    }, [dispatch, transferValues.accountNumber]);

    return null;
}

const AccountConfirmationLetter = () => {

    const accountsList = useSelector(selectAccountsByFilter)
    const accountTopUpList = useSelector(selectTopUpByAccount)
    const dispatch = useAppDispatch()
    const selectedAccountForConfirmationLetter = useSelector(selectAccountForConfirmationLetter)
    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
    const [isChecked, setIsChecked] = useState<boolean>(false)
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [isPDFDownloadSuccessfully, setIsPDFDownloadSuccessfully] = useState<boolean | null>(null);
    const [accountNumber, setAccountNumber] = useState<string>("");
    const token = useAppSelector(state => state.userReducer.userToken)

    const clearFilters = () => {
        dispatch(setFiltersTemplates(
            {
                accountNumber: '',
                period: null,
                from: '',
                to: '',
                purpose: '',
                recipient: '',
                amount: '',
                incoming: false,
                outgoing: false,
                currency: '',
                selectedType: '',
                templateName: '',
                paymentRegion: ''
            }
        ))
    }

    useEffect(() => {
        return clearFilters()
    }, [accountTopUpList])

    const openPdfPopup = () => {
        if (!selectedAccountForConfirmationLetter) {
            return
        }

        setIsChecked(false)
        setIsConfirmationModalOpen(true)
    }

    const getPdf = async () => {

        try {
            const response = await dispatch(getAccountConfirmationLetterThunk(token, accountId, selectedAccountForConfirmationLetter.number))

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'account_confirmation_letter.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            setIsPDFDownloadSuccessfully(true)
        } catch (e: any) {

            const contentType = e.response.headers['content-type'];
            if (contentType && contentType.includes('application/json')) {
                const errorData = await e.response.data; // Это будет Blob
                const reader = new FileReader();

                reader.onload = () => {
                    try {
                        if (typeof reader.result === "string") {
                            const jsonError = JSON.parse(reader.result);
                            const message = jsonError.detail || jsonError.title || jsonError;
                            // "Invalid authorization data"
                                if (message === "Error: Conflict") {
                                    dispatch(setTokenState(false))
                                    return
                                }

                                if (message === "Not enough money in accounts for commission") {
                                    setIsPDFDownloadSuccessfully(false)
                                    return
                                }

                                 if (message.toLowerCase().includes("pdf template not found")) {
                                console.error("PDF Template Error:", message);
                                return
                                }

                        }

                    } catch (e) {
                        console.log('Unresolved error.')
                    }
                };

                reader.readAsText(errorData);
            } else {
                console.log("not json")
            }
        } finally {
            setIsConfirmationModalOpen(false)
        }
    }

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >

            <CustomModal type="confirm" isNotify isModalOpen={isPDFDownloadSuccessfully} setIsModalOpen={setIsPDFDownloadSuccessfully}>
                <div className={styles.modal_content}>
                    <div className={styles.popup_subtitle}>
                        <span className={styles.success}>Success!</span> The write-off was successful.
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn isPersonalAccountBtn title={"Ok"} onClick={() => {setIsPDFDownloadSuccessfully(null)}}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal type="error" isNotify isModalOpen={isPDFDownloadSuccessfully === false} setIsModalOpen={setIsPDFDownloadSuccessfully}>
                <div className={styles.modal_content}>
                    <div className={styles.popup_subtitle}>
                        <span className={styles.error}>Failed!</span> Write-off cannot be made due to insufficient funds.
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn isPersonalAccountBtn buttonType={"error"} title={"Ok"} onClick={() => {setIsPDFDownloadSuccessfully(null)}}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal isModalOpen={isConfirmationModalOpen} type={"info"}>
                <div className={styles.modal_content}>
                    <img src={iconInfo} alt="" className={styles.popup_icon}/>
                    <div className={styles.popup_title1}>
                        <div className={s.popup_text_block}>
                            This is a paid service
                        </div>
                    </div>
                    <div className={styles.popup_subtitle1}>
                        <div className={s.popup_text_block}>
                            50 EUR will be deducted from your account.
                        </div>
                    </div>
                    <div className={s.popup_checkbox}>
                        <div className={s.checkbox_content}>
                            <CustomCheckbox1
                               onChange={() => setIsChecked(!isChecked)}
                               checked={isChecked}
                               id={'feeCheckbox'}
                               name={'feeCheckbox'}
                            />
                            <span className={s.checkbox_text}>
                                I agree with 50 EUR fee
                            </span>
                        </div>
                    </div>
                    <div className={styles.buttonWrapper}>
                        <div className={styles.popup_button_block}>
                            <TransparentButton
                                isPersonalAccountBtn
                                title={"Cancel"}
                                onClick={() => setIsConfirmationModalOpen(false)}
                                medium
                                buttonType={"info"}
                            />
                        </div>
                        <div className={styles.popup_button_block}>
                            <MyBtn
                                isPersonalAccountBtn
                                title={"Confirm"}
                                type={"submit"}
                                buttonType={"info"}
                                onClick={() => getPdf()}
                                localDisable={!isChecked}
                            />
                        </div>
                    </div>
                </div>
            </CustomModal>

            <div className={`${s.statementWrapper} ${accountNumber !== "" ? s.active : ""}`}>
                {
                    
                    <div className={s.buttonsWrapper}>
                        <p className={s.downloadTitle}>Download as</p>
                        <p className={s.buttonTitle} onClick={() => openPdfPopup()}>PDF</p>
                    </div>
                }
            </div>
            <div>
                <Formik
                    initialValues={{
                        accountNumber: '',
                    }}
                    onSubmit={(values) => {}}
                >
                    {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit
                      }) => (
                        <form className={s.form} onSubmit={handleSubmit}>
                            <div className={s.dropdown_wrapper}>
                                <p className={s.labelText}>
                                    Account Number
                                    <Popover content={"Please select the account for which you want to download an account confirmation letter."}
                                             color={'#EEEFEF'}
                                             overlayInnerStyle={{
                                                 fontFamily: 'Manrope',
                                                 width: '280px',
                                                 padding: '13px 16px',
                                                 cursor: 'pointer',
                                                 backgroundColor: '#E7F0EC'
                                             }}
                                    >
                                        <img src={info} alt="" className={s.info_circle}/>
                                    </Popover>
                                </p>
                                <CustomDropdownForAccounts
                                    items={accountsList}
                                    id={'accountNumber'}
                                    name={'accountNumber'}
                                    setAccountNumber={setAccountNumber}
                                />
                            </div>
                            {(accountTopUpList?.all.length > 0 && accountTopUpList?.all)
                                ? accountTopUpList.all.map((e: any, key: any) => (
                                    <div className={s.data_wrapper} key={key}>
                                        <div className={s.row}>
                                            <span>Recipient Name</span>
                                            <span><b>{e.beneficiaryName}</b></span>
                                        </div>
                                        <div className={s.row}>
                                            <span>Recipient Account</span>
                                            <span><b>{e.iban}</b></span>
                                        </div>
                                        <div className={s.row}>
                                            <span>BIC Code</span>
                                            <span><b>{e.swift}</b></span>
                                        </div>
                                        <div className={s.row}>
                                            <span>Bank Name</span>
                                            <span><b>{e.bankName}</b></span>
                                        </div>
                                        <div className={s.row}>
                                            <span>Bank Address</span>
                                            <span><b>{e.bankAddress}</b></span>
                                        </div>
                                    </div>
                                ))
                                : <div></div>
                            }
                            <DetailsForBankTransferHelper transferValues={values} />
                        </form>)}
                </Formik>
            </div>
        </motion.div>
    );
};

export default AccountConfirmationLetter;
